module.exports = __webpack_public_path__ + "static/media/mg.91114d9e.svg";